module.exports = __webpack_public_path__ + "img/vorkasse.9153901b.png";